import { render } from "./salesreport.vue?vue&type=template&id=58dd3f4d"
import script from "./salesreport.vue?vue&type=script&lang=js"
export * from "./salesreport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__